import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ProgramacaoDisparoModel } from '../model/disparo-automatico/programacao-disparo.model';
import { PageModel } from '../model/page-mode.model';
import { LogRotina } from '../model/log-rotina.model';
import {DisparoAutomaticoFiltro} from '../model/disparo-automatico/disparo-automatico-filtro.model';
import {IdNome} from '../model/id-nome.model';

@Injectable({
  providedIn: 'root'
})
export class ProgramacaoDisparoService {

  private http = inject(HttpClient);
  private urlBase = `${environment.urlBase}`;

  salvarProgramacao(programacao: ProgramacaoDisparoModel): Observable<number> {
    return this.http.post(`${this.urlBase}/programacao-disparo`, programacao, { responseType: 'text' }).pipe(
      map(resposta => Number(resposta))
    );
  }

  buscarProgramacoes(page: number, limit: number, filtro: DisparoAutomaticoFiltro): Observable<PageModel> {
    return this.http.post<PageModel>(`${this.urlBase}/programacao-disparo/buscar`, DisparoAutomaticoFiltro.payload(filtro), {
      params: { page, limit }
    });
  }

  buscarProgramacoesAtivas(): Observable<IdNome[]> {
    return this.http.get<IdNome[]>(`${this.urlBase}/programacao-disparo/ativas`);
  }

  buscarProgramacao(programacaoId: number): Observable<ProgramacaoDisparoModel> {
    return this.http.get<ProgramacaoDisparoModel>(`${this.urlBase}/programacao-disparo/${programacaoId}`);
  }

  buscarProgramacaoPorUuid(uuid: string): Observable<ProgramacaoDisparoModel> {
    return this.http.get<ProgramacaoDisparoModel>(`${this.urlBase}/programacao-disparo/uuid/${uuid}`);
  }

  cancelarProgramacao(programacaoId: number): Observable<void> {
    return this.http.patch<void>(`${this.urlBase}/programacao-disparo/${programacaoId}/cancelar`, {});
  }

  buscarLogs(programacaoId: number): Observable<LogRotina[]> {
    return this.http.get<LogRotina[]>(`${this.urlBase}/programacao-disparo/${programacaoId}/logs`);
  }
}
